export default __webpack_public_path__ + "static/media/search.f58b5ca5.svg";